// src/app/layout/Header.tsx
import { Menu } from 'lucide-react';
import { useAuthStore } from '@vanialabs/core-auth';

/**
 * Placeholder header. Reads only the display name from core-auth's
 * session -- no menu/notification logic yet, kept intentionally minimal
 * so it doesn't compete with the dashboard's own WelcomeHeader.
 *
 * Below lg, also renders a hamburger button that opens the
 * MobileNavDrawer (state owned by AppLayout). At lg and up the button
 * is hidden via lg:hidden, so desktop appearance is unchanged.
 */
interface HeaderProps {
  onOpenNav: () => void;
}

export function Header({ onOpenNav }: HeaderProps) {
  const userName = useAuthStore((state) => state.session?.user.name);

  return (
    <header className="flex items-center justify-between gap-3 border-b border-[var(--vania-colors-border-subtle,rgba(255,255,255,0.08))] px-4 sm:px-6 py-3 min-w-0">
      <div className="flex min-w-0 items-center gap-3">
        <button
          type="button"
          onClick={onOpenNav}
          aria-label="باز کردن منو"
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg text-[var(--vania-colors-text-secondary,#a3aab8)] transition-colors hover:bg-[var(--vania-colors-surface-secondary,rgba(255,255,255,0.06))] lg:hidden"
        >
          <Menu size={18} strokeWidth={2.2} />
        </button>
        <span className="min-w-0 truncate text-sm font-semibold text-[var(--vania-colors-text-primary,#f5f6fa)]">
          پنل نمایندگان VaniaLabs
        </span>
      </div>
      {userName && (
        <span className="min-w-0 shrink-0 truncate text-sm text-[var(--vania-colors-text-secondary,#a3aab8)]">{userName}</span>
      )}
    </header>
  );
}
